// @tennis-matches/services/governance
// Server-seitige Superadmin-Prüfung (funktioniert auch wenn Client role_bindings nicht lesen kann).

import { getSupabaseClient } from "../supabase/index.js";
import {
  isMissingRestResourceError,
  isRestEndpointUnavailable,
  markRestEndpointUnavailable,
} from "../supabase/rest-endpoint-availability.js";

const RPC_KEY = "rpc:is_superadmin";
const CACHE_TTL_MS = 60_000;

/** @type {Promise<{ ok: boolean, isSuperadmin: boolean, rpcMissing?: boolean, reason?: string, error?: unknown }>|null} */
let __inflight = null;
/** @type {{ at: number, result: { ok: boolean, isSuperadmin: boolean, rpcMissing?: boolean, reason?: string, error?: unknown } } | null} */
let __cache = null;

/**
 * Ruft `public.is_superadmin()` auf (delegiert an `app_config.is_global_superadmin()`).
 * @returns {Promise<{ ok: boolean, isSuperadmin: boolean, rpcMissing?: boolean, reason?: string, error?: unknown }>}
 */
export async function checkIsGlobalSuperadminRemote() {
  if (isRestEndpointUnavailable(RPC_KEY)) {
    return { ok: true, isSuperadmin: false, rpcMissing: true };
  }
  if (__cache && Date.now() - __cache.at < CACHE_TTL_MS) {
    return __cache.result;
  }
  if (__inflight) return __inflight;

  __inflight = (async () => {
    const supabase = await getSupabaseClient();
    if (!supabase) return { ok: false, isSuperadmin: false, reason: "no-supabase" };

    try {
      const { data, error } = await supabase.rpc("is_superadmin");
      if (error) {
        if (isMissingRestResourceError(error)) {
          markRestEndpointUnavailable(RPC_KEY);
          markRestEndpointUnavailable("rpc:list_role_app_access:global:global");
          const out = { ok: true, isSuperadmin: false, rpcMissing: true };
          __cache = { at: Date.now(), result: out };
          return out;
        }
        return { ok: false, isSuperadmin: false, reason: "rpc-error", error };
      }
      const out = { ok: true, isSuperadmin: data === true };
      __cache = { at: Date.now(), result: out };
      return out;
    } catch (e) {
      if (isMissingRestResourceError(e)) {
        markRestEndpointUnavailable(RPC_KEY);
        markRestEndpointUnavailable("rpc:list_role_app_access:global:global");
        const out = { ok: true, isSuperadmin: false, rpcMissing: true };
        __cache = { at: Date.now(), result: out };
        return out;
      }
      return { ok: false, isSuperadmin: false, reason: "exception", error: e };
    }
  })();

  try {
    return await __inflight;
  } finally {
    __inflight = null;
  }
}
